import { z } from "zod/v4";
import { fontWeights } from "../brand-kit";
import { zExt } from "../common/zod-util";
import { FaqForgeElementType, FaqJustify } from "../forge/faq-forge-types";

const baseFaqRichTextElementSchema = z.object({
  id: z.string(),
  html: z.string(),
  fontFamily: z.string(),
  fontWeight: z.enum(fontWeights),
  fontSizePx: z.number(),
  textColor: z.string(),
  linkColor: z.string(),
});

const faqRichTextElementSchema_ = baseFaqRichTextElementSchema.extend({
  type: z.literal(FaqForgeElementType.RICH_TEXT),
});
const faqRichTextElementSchema: z.ZodType<FaqRichTextElement> =
  faqRichTextElementSchema_;
export interface FaqRichTextElement
  extends z.infer<typeof faqRichTextElementSchema_> {}

const faqH1ElementSchema_ = baseFaqRichTextElementSchema.extend({
  type: z.literal(FaqForgeElementType.H1),
});
const faqH1ElementSchema: z.ZodType<FaqH1Element> = faqH1ElementSchema_;
export interface FaqH1Element extends z.infer<typeof faqH1ElementSchema_> {}

const faqH2ElementSchema_ = baseFaqRichTextElementSchema.extend({
  type: z.literal(FaqForgeElementType.H2),
});
const faqH2ElementSchema: z.ZodType<FaqH2Element> = faqH2ElementSchema_;
export interface FaqH2Element extends z.infer<typeof faqH2ElementSchema_> {}

const faqH3ElementSchema_ = baseFaqRichTextElementSchema.extend({
  type: z.literal(FaqForgeElementType.H3),
});
const faqH3ElementSchema: z.ZodType<FaqH3Element> = faqH3ElementSchema_;
export interface FaqH3Element extends z.infer<typeof faqH3ElementSchema_> {}

const faqImageElementSchema_ = z.object({
  type: z.literal(FaqForgeElementType.IMAGE),
  url: z.string(),
  width: z.optional(z.number()),
  justify: z.enum(FaqJustify),
});
const faqImageElementSchema: z.ZodType<FaqImageElement> =
  faqImageElementSchema_;
export interface FaqImageElement
  extends z.infer<typeof faqImageElementSchema_> {}

const faqVideoElementSchema_ = z.object({
  type: z.literal(FaqForgeElementType.VIDEO),
  url: z.string(),
  width: z.number(),
  justify: z.enum(FaqJustify),
});
const faqVideoElementSchema: z.ZodType<FaqVideoElement> =
  faqVideoElementSchema_;
export interface FaqVideoElement
  extends z.infer<typeof faqVideoElementSchema_> {}

const faqDividerElementSchema_ = z.object({
  type: z.literal(FaqForgeElementType.DIVIDER),
});
const faqDividerElementSchema: z.ZodType<FaqDividerElement> =
  faqDividerElementSchema_;
export interface FaqDividerElement
  extends z.infer<typeof faqDividerElementSchema_> {}

const faqToggleElementSchema_ = z.object({
  type: z.literal(FaqForgeElementType.TOGGLE),
  title: z.string(),
  child: z.string(),
});
const faqToggleElementSchema: z.ZodType<FaqToggleElement> =
  faqToggleElementSchema_;
export interface FaqToggleElement
  extends z.infer<typeof faqToggleElementSchema_> {}

export const faqElementSchema = z.union([
  faqH1ElementSchema,
  faqH2ElementSchema,
  faqH3ElementSchema,
  faqRichTextElementSchema,
  faqImageElementSchema,
  faqVideoElementSchema,
  faqDividerElementSchema,
  faqToggleElementSchema,
]);

export const FaqCollectionDbParser_ = z.object({
  _id: zExt.objectId(),
  team: zExt.objectId(),
  title: z.string(),
  description: z.string(),
  articles: z.array(zExt.objectId()),
  published: z.boolean(),
});
export const FaqCollectionDbParser: z.ZodType<FaqCollection> =
  FaqCollectionDbParser_;
export interface FaqCollection extends z.infer<typeof FaqCollectionDbParser_> {}
export type IFaqCollection = FaqCollection;

export const FaqCollectionArrayDbParser_ = z.array(FaqCollectionDbParser_);
export const FaqCollectionArrayDbParser: z.ZodType<FaqCollection[]> =
  FaqCollectionArrayDbParser_;
export type FaqCollectionArray = z.infer<typeof FaqCollectionArrayDbParser_>;

export const FaqArticleDbParser_ = z.object({
  _id: zExt.objectId(),
  team: zExt.objectId(),
  title: z.string(),
  faqCollection: zExt.objectId(),
  elements: z.array(faqElementSchema),
  published: z.boolean(),
  lastEditedAt: z.date(),
});
export const FaqArticleDbParser: z.ZodType<FaqArticle> = FaqArticleDbParser_;
export interface FaqArticle extends z.infer<typeof FaqArticleDbParser_> {}
export type IFaqArticle = FaqArticle;

const FaqArticleArrayDbParser_ = z.array(FaqArticleDbParser_);
export const FaqArticleArrayDbParser: z.ZodType<FaqArticle[]> =
  FaqArticleArrayDbParser_;
export type FaqArticleArray = z.infer<typeof FaqArticleArrayDbParser_>;
